var map = {
	"./active.svg": "90fa",
	"./add-curve.svg": "4dc9",
	"./add-doc.svg": "c39a",
	"./add.svg": "3592",
	"./archive.svg": "6ff0",
	"./arrow-down.svg": "b910",
	"./arrow-left.svg": "c633",
	"./arrow-right.svg": "2a29",
	"./arrow-up.svg": "3cdf",
	"./back.svg": "a78c",
	"./bell.svg": "3cc2",
	"./calculator.svg": "859c",
	"./calendar.svg": "aa21",
	"./cancel.svg": "ad05",
	"./caret-down.svg": "39a4",
	"./caret-left.svg": "d480",
	"./caret-right.svg": "4cb6",
	"./caret-up.svg": "0ce2",
	"./change-password.svg": "fb51",
	"./check.svg": "bc4a",
	"./chemistry.svg": "519e",
	"./close.svg": "e67b",
	"./contact-form.svg": "c13e",
	"./copy.svg": "2aa4",
	"./coworking.svg": "fb01",
	"./data-exchange.svg": "5595",
	"./database.svg": "2d20",
	"./delete.svg": "b248",
	"./earth.svg": "d114",
	"./edit.svg": "f232",
	"./event.svg": "d2c9",
	"./eye.svg": "ff6e",
	"./file-csv.svg": "165e",
	"./folder.svg": "2a33",
	"./home.svg": "7e04",
	"./inspection.svg": "3c5a",
	"./lab-technician.svg": "c8ee",
	"./language.svg": "8767",
	"./login.svg": "546b",
	"./logout.svg": "9629",
	"./map.svg": "8d3c",
	"./measuring.svg": "d2e9",
	"./menu-side.svg": "ae68",
	"./menu.svg": "b778",
	"./microbiology.svg": "08d4",
	"./microscope.svg": "7a1a",
	"./my-image (1).png": "f2e6",
	"./my-image (2).png": "249a",
	"./my-image (3).png": "316e",
	"./my-image (4).png": "53d7",
	"./my-image.png": "15e7",
	"./not-found.svg": "c1da",
	"./org-chart.svg": "4fa6",
	"./password.svg": "3bae",
	"./pdf.svg": "ad90",
	"./plus-btn.svg": "31c9",
	"./plus-frame.svg": "66277",
	"./plus.svg": "871b",
	"./printer.svg": "938c",
	"./profile.svg": "b8d1",
	"./rate.svg": "8b8a",
	"./refresh-circle.svg": "5bbd",
	"./refresh-green.svg": "f308",
	"./refresh.svg": "94cf",
	"./reload.svg": "7a99",
	"./report.svg": "b950",
	"./reset.svg": "8231",
	"./resource.svg": "19fd",
	"./responsible.svg": "1f95",
	"./role.svg": "c74c",
	"./save.svg": "5cb3",
	"./search.svg": "08e1",
	"./select.svg": "fcc9",
	"./setting.svg": "afae",
	"./sign-form.svg": "989d",
	"./state.svg": "da2e",
	"./test.svg": "74a9",
	"./testing-chemi.svg": "651b",
	"./toggle-sidebar-left.svg": "cfd9",
	"./toggle-sidebar-right.svg": "b959",
	"./trolley.svg": "2b74",
	"./upload.svg": "93a9",
	"./user.svg": "d710c",
	"./username.svg": "fb73",
	"./warning.svg": "10f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8873";